









































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CURRENCY_FORMAT, FIXED_POINT_FORMAT } from '@/helpers/currency';
import ApiClient from '@/data/ApiClient';

import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import contactsRepository from '@/services/contactsRepository';
import notificationService from '@/services/notificationService';
import { DxTabs } from 'devextreme-vue';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';

import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import SavedBar from '@/modules/shared/savebar/SaveBar.vue';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';
import ContractMailPopup from '@/modules/projects/contracts/components/ContractMailPopup.vue';
import UploadSignedContractPopup from '@/modules/projects/contracts/components/UploadSignedContractPopup.vue';
import {
  IContractDto,
  ContractsClient,
  UpdateContractCommand,
  ContractLine,
  FinanceDocumentSettings,
  ArticleCategory,
  ArticleCategoryClient,
  Settings,
  TunnelGroup,
  TunnelGroupsClient,
} from '@/data/web-api-client';
import { EntityType, SummaryItem } from '@/components/articles/articleSummaryTable.vue';
import { groupBy } from '@/helpers/Helper';
import ArticleSummaryTable from '@/components/articles/articleSummaryTable.vue';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    Card,
    Datagrid,
    EventLogsTable,
    UploadSignedContractPopup,
    PdfViewer,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    SavedBar,
    DxTabs,
    ContractMailPopup,
    ArticleSummaryTable,
  },
})
export default class ContractDetailPage extends Vue {
  entityType: EntityType = 'Contract';

  contract: IContractDto = {
    documentNumber: '',
    projectId: '',
    projectType: '',
    date: undefined,
    subcontractorId: '',
    subcontractorName: '',
    measuringStateRef: '',
    status: 0,
    fileUrl: '',
    lines: [],
    fixedPrice: undefined,
    total: 0,
    reference: '',
    tunnelGroupsId: '',
  };
  saving: boolean = false;
  loading: boolean = true;
  dirty: boolean = false;
  showDocument = false;
  navIndex: number = 0;
  documentAsUrl: string = '';
  loadingDocument: boolean = false;
  pdfSize: number = 450;
  disabled = false;
  documentSettings: FinanceDocumentSettings = new FinanceDocumentSettings({
    hideUnitPrices: false,
    hideLineTotals: false,
    hideLineAmounts: false,
    hideSubtotals: false,
    hideTotals: false,
    hideSubtotalDetails: false,
    language: undefined,
    groupArticlesByCategory: false,
  });
  languages: any[] = [];

  public articleCategories: ArticleCategory[] = [];
  public tunnelGroups: TunnelGroup[] = [];

  contractsClient = new ContractsClient(undefined, this.$axios);

  async loadData() {
    try {
      this.loading = true;
      this.contract = await this.contractsClient.getSingle(this.$route.params.documentNumber);
      this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();
      this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();

      this.disabled = this.contract.projectIsOnHold!;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      setTimeout(() => {
        this.loading = false;
      }, 150);
    }
  }

  async mounted() {
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];

    await this.loadData();
    this.pdfSize = window.innerHeight - 275;
  }

  async loadDocument() {
    try {
      this.loadingDocument = true;
      this.documentAsUrl = '';
      const document = (await ApiClient.projects.contracts.document.download(this.contract.documentNumber!)).data;
      this.documentAsUrl = window.URL.createObjectURL(document);
    } catch {
      // Do nothing
    } finally {
      this.loadingDocument = false;
    }
  }

  async generateDocument() {
    try {
      this.saving = true;

      await ApiClient.projects.contracts.document.generate(this.contract.documentNumber!, this.documentSettings);
      this.loadData();
      this.loadDocument();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  showMailPopup() {
    (this.$refs.ContractMailPopup as ContractMailPopup).show();
  }

  showUploadContractPopup() {
    (this.$refs.UploadSignedContractPopup as UploadSignedContractPopup).open();
  }

  async accept() {
    try {
      this.saving = true;
      await ApiClient.projects.contracts.actions.accept(this.contract.documentNumber!);
      this.loadData();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async reject() {
    try {
      this.saving = true;
      await ApiClient.projects.contracts.actions.reject(this.contract.documentNumber!);
      this.loadData();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async resetPrices() {
    try {
      this.saving = true;
      await ApiClient.projects.contracts.actions.resetPrices(this.contract.documentNumber!);
      this.loadData();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async save() {
    try {
      this.saving = true;
      const command = new UpdateContractCommand({
        documentNumber: this.contract.documentNumber,
        status: this.contract.status,
        projectId: this.contract.projectId,
        projectType: this.contract.projectType,
        date: this.contract.date,
        subcontractorId: this.contract.subcontractorId,
        fixedPrice: this.contract.fixedPrice,
        reference: this.contract.reference,
        lines: this.contract.lines?.map((l) => ContractLine.fromJS(l)),
      });
      await this.contractsClient.putContract(this.contract.documentNumber!.replaceAll('/', '-'), command);
      this.dirty = false;
      this.loadData();
      notificationService.saved();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  mail() {
    // (this.$refs.mailDialog as contractMailDialog).show = true;
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  get status() {
    const statusOption = ApiClient.projects.contracts.getStatusOptions().find((o) => o.value === this.contract.status);

    if (statusOption) {
      return statusOption.text;
    }

    return '';
  }

  get tunnelGroupName() {
    if (!this.contract.tunnelGroupsId) {
      return '';
    }

    return this.tunnelGroups.find((tg) => tg.id === this.contract.tunnelGroupsId)?.name ?? '';
  }

  get toolbarOptions() {
    return [
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-sync',
          text: 'Prijzen resetten',
          stylingMode: 'outlined',
          type: 'default',
          onClick: () => {
            this.resetPrices();
          },
          disabled: this.disabled,
        },
      },
    ];
  }

  get projecttypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');

    return {
      items: catalog ? catalog.values : [],
      searchEnabled: true,
    };
  }

  get statusOptions() {
    /*
    Open = 0,
            Approved = 1,
            Rejected = 2,
            Send = 3,
    */
    const catalog = [
      { value: 0, text: 'Open' },
      { value: 3, text: 'Verstuurd' },
      { value: 1, text: 'Aanvaard' },
      { value: 2, text: 'Afgewezen' },
    ];

    return {
      items: catalog ? catalog : [],
      searchEnabled: true,
      displayExpr: 'text',
      valueExpr: 'value',
    };
  }

  get subcontractorOptions() {
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions: any) => {
            const result = await contactsRepository.lookup(loadOptions, undefined, 'Subcontractor', this.contract?.tunnelGroupsId);
            return result.data;
          },
          byKey: async (val: any) => {
            const result = await contactsRepository.getSingle(val);
            return result.data;
          },
        }),
        paginate: true,
      }),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
    };
  }

  get articles() {
    return this.$store.getters['articles/items'];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectName: this.contract.documentNumber,
      type: EventLogsObjectType.Contract,
    };
  }

  rowChange(e: any) {
    e.cancel = new Promise((resolve, reject) => {
      // executor (the producing code, "singer")
      if (e.newData.hasOwnProperty('articleId') && !e.newData.hasOwnProperty('description')) {
        const article = (this.articles as IArticle[]).find((o) => o.id === e.newData.articleId);
        if (article) {
          Object.assign(e.newData, {
            description: `${article.name}: ${article.description}`,
          });
        }
      }
      resolve(false);
    });
  }

  get codeSummary(): SummaryItem[] {
    const summaryByCategories = this.settings.summaryInCategories;
    let result: SummaryItem[] = [];

    if (!this.contract) {
      return result;
    }

    if (summaryByCategories) {
      const allLines = this.contract.lines!;

      const groupedLinesByCategory: Map<string, ContractLine[]> = groupBy(allLines, 'articleCategoryId');

      for (const [key, values] of groupedLinesByCategory) {
        var groupedLines: Map<string, ContractLine[]> = groupBy(values, 'description');
        for (const [articleId, lines] of groupedLines) {
          if (lines.length == 0) continue;

          let line = lines[0];

          const amountSum = lines.reduce((a: number, { amount }) => a + amount!, 0);
          const totalSum = lines.reduce((a: number, { total }) => a + total!, 0);

          const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);
          if (resultIndex === -1) {
            result.push({
              articleId: line.articleId!,
              description: line.description!,
              quantity: amountSum,
              unitPrice: totalSum!,
              articleCategoryId: line.articleCategoryId!,
            });
          } else {
            result[resultIndex].quantity += amountSum;
            result[resultIndex].unitPrice += totalSum!;
          }
        }
      }

      result.forEach((resultItem) => {
        resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
      });

      return result;
    }

    // summary not grouped by categories
    for (const line of this.contract.lines!) {
      if (line.articleId && line.articleId !== '' && line.amount && line.total) {
        const resultIndex = result.findIndex((o) => o.articleId === line.articleId && o.description === line.description);
        if (resultIndex === -1) {
          result.push({
            articleId: line.articleId,
            description: line.description!,
            quantity: line.amount,
            unitPrice: line.total,
            articleCategoryId: line.articleCategoryId!,
          });
        } else {
          result[resultIndex].quantity += line.amount;
          result[resultIndex].unitPrice += line.total;
        }
      }
    }

    result.forEach((resultItem) => {
      resultItem.unitPrice = resultItem.unitPrice / resultItem.quantity;
    });

    return result;
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Info' },
      { icon: 'fas fa-info-circle', text: 'Samenvatting' },
      { icon: 'fas fa-file-pdf', text: 'Document' },
      { icon: 'fas fa-history', text: 'Logs' },
    ];
  }

  get columns() {
    const columns: any[] = [
      {
        dataField: 'articleId',
        caption: this.$t('objects.contracts.fields.lines.Article'),
        lookup: {
          dataSource: this.articles,
          displayExpr(val: any) {
            return `${val.name}`;
          },
          valueExpr: 'id',
        },
      },
      {
        dataField: 'description',
        caption: 'Omschrijving',
      },
      {
        dataField: 'amount',
        caption: this.$t('objects.contracts.fields.lines.Amount'),
        dataType: 'number',
        alignment: 'left',
        format: FIXED_POINT_FORMAT,
      },
      {
        dataField: 'price',
        caption: this.$t('objects.contracts.fields.lines.Price'),
        dataType: 'number',
        alignment: 'left',
        format: CURRENCY_FORMAT,
      },
      {
        // dataField: 'total',
        caption: this.$t('objects.contracts.fields.lines.Total'),
        dataType: 'number',
        alignment: 'left',
        format: CURRENCY_FORMAT,
        calculateDisplayValue(value: any) {
          let result = 0;
          result = value.amount * value.price;
          result = Math.round(result * 100) / 100;
          return result;
        },
      },
    ];

    if (!this.disabled) {
      columns.push({
        type: 'buttons',
        buttons: ['edit', 'delete'],
      });
    }

    return columns;
  }

  get settings() {
    return this.$store.getters['settings/data'];
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
      value: this.documentSettings?.language,
    };
  }

  @Watch('contract', { deep: true })
  onContractChanged() {
    if (!this.loading) {
      this.dirty = true;
    }
  }

  @Watch('navIndex')
  onNavigationChanged() {
    if (this.navIndex === 2 && this.documentAsUrl === '') {
      this.loadDocument();
    }
  }
}
